import { render } from "./NextSottoProgettoTable.vue?vue&type=template&id=3c56aacb&ts=true"
import script from "./NextSottoProgettoTable.vue?vue&type=script&lang=ts"
export * from "./NextSottoProgettoTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__